<template>
	<div :class="['info-box', 'info-box-' + type, { 'with-icon': withIcon }]">
		<div>
			<Icon v-if="withIcon" :icon="icon"/>
		</div>
		<div>
			<slot/>
		</div>
	</div>
</template>

<script>
import Icon from "@/vue/icon/Icon";

const TYPE_NEUTRAL = 'neutral';
const TYPE_ERROR = 'error';
const TYPE_SUCCESS = 'success';
const TYPE_WARNING = 'warning';

const ICONS = {
	[TYPE_NEUTRAL]: 'info',
	[TYPE_ERROR]: 'cross-circle',
	[TYPE_SUCCESS]: 'check-circle',
	[TYPE_WARNING]: 'exclamation-triangle',
};

export default {

	components: {
		Icon,
	},

	props: {
		type: {
			type: String,
			required: false,
			default: 'neutral'
		},
		withIcon: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	computed: {
		icon ()
		{
			return ICONS[this.type];
		},
	}
}
</script>